export enum DesktopOS {
	windows = 'windows',
	macos = 'macos',
	other = 'other',
}

/**
 * @description Detect desktop OS.
 * @returns {DesktopOS} Desktop OS.
 */
export function getDesktopOS(): DesktopOS {
	const { userAgent } = window.navigator;
	if (/Mac OS/.test(userAgent)) {
		return DesktopOS.macos;
	}

	if (/Windows/.test(userAgent)) {
		return DesktopOS.windows;
	}

	return DesktopOS.other;
}
